module.exports = __webpack_public_path__ + "img/bangcrush.af27b1f4.jpg";